import { colors } from "./colors";
import { pxToRem } from "./utils";
export var shadows = {
    card_overlay: "".concat(pxToRem(0, 2, 8), " ").concat(colors.$000000_16)
};
